import { AmplifyCore, commonEnums as enums } from '@codametrix/ui-common';

type CoderViewV2Inputs = Pick<
  CMx.InterfaceState,
  'context' | 'roles' | 'serviceLine'
>;

export const isCoderViewV2User = ({
  context,
  roles,
  serviceLine
}: CoderViewV2Inputs): boolean =>
  !!context.activeContext &&
  roles.some(role => role.roleName === 'coder') &&
  AmplifyCore.benchEditable.isResourceAllowed(
    context.activeContext,
    enums.ResourceId.CODER_VIEW_V2,
    serviceLine?.name ?? ''
  );

const BARE_WORKLIST = /^(\/cmx\/)?worklist\/?(?=\?|$)/;

export const canonicalBackToWorklistPath = (
  path: string | null | undefined,
  coderViewV2: boolean
): string | null | undefined =>
  path?.replace(
    BARE_WORKLIST,
    (_match, prefix: string | undefined) =>
      `${prefix ?? ''}worklist/${coderViewV2 ? 'V2' : 'V1'}`
  ) ?? path;
